(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // Disable print immediately
    let printingBlocked = true;

    document.addEventListener("keydown", (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "p") {
        if (printingBlocked) {
          e.preventDefault();
          return false;
        }
      }
    });

    const linksContainer = document.getElementById("js-page-links");

    if (linksContainer) {
      // find the main content wrapper
      const contentWrapper = document.querySelector("main");

      if (!contentWrapper) return;

      // add a 2.5s timeout so that we can ensure all page
      // links have been generated
      setTimeout(() => {
        // Enable print again
        printingBlocked = false;

        const printButtons = document.querySelectorAll(".js-print-button");

        if (printButtons.length) {
          printButtons.forEach(function (printButton, index) {
            if (printButton) {
              printButton.addEventListener("click", () => {
                window.print();
    
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                  event: "printButtonClick",
                });
              });
            }
          });
        }

        const allLinks = Array.from(contentWrapper.querySelectorAll("a"));

        if (!allLinks || allLinks.length == 0) return;

        // common social platforms
        const socialPlatforms = [
          "facebook.com/sharer",
          "facebook.com/share",
          "linkedin.com/sharing",
          "linkedin.com/share",
          "twitter.com/share",
          "twitter.com/intent/tweet",
          "pinterest.com/pin",
          "reddit.com/submit",
          "tumblr.com/share",
          "whatsapp://send",
          "telegram.me/share",
          "share?url=",
          "/share/",
          "sharethis.com",
          "addthis.com",
        ];

        // filter out empty and scroll links
        const links = allLinks.filter((el) => {
          // Convert to lowercase for case-insensitive matching
          const link = el.href.toLowerCase();

          return !(
            !el.href || // empty href
            el.href.trim() === "" || // whitespace-only href
            link.includes("#lf-doc") ||
            link.startsWith("mailto:") ||
            link.startsWith("tel:") ||
            link.startsWith("sms:") ||
            link.startsWith("skype:") ||
            link.startsWith("whatsapp:") ||
            link.startsWith("facetime:") ||
            // filter out social share links
            socialPlatforms.some((platform) => link.includes(platform))
          );
        });

        if (links.length == 0) {
          // hide links section
          linksContainer.style.display = "none";

          return;
        }

        const listElement = document.createElement("ul");
        linksContainer.appendChild(listElement);

        links.forEach((link) => {
          const index = links.indexOf(link) + 1;

          link.insertAdjacentHTML(
            "afterend",
            `<sup class="link-index">&nbsp;[L${index}]</sup>`
          );

          listElement.insertAdjacentHTML(
            "beforeend",
            `<li>L${index}. ${link.href}</li>`
          );
        });
      }, 2500);
    }
  });
})();
